import { useEffect, useState } from 'react'
import { useUser } from '../UserContext'
import './AdStyles.css'
import PropTypes from 'prop-types'
import BannerAd from './BannerAd'

function GameroomsAd({ AdUnitId }) {
  const { user } = useUser()
  const [leftMargin, setLeftMargin] = useState(
    user.token ? (window.innerWidth > 1100 ? '250px' : '0px') : '0px'
  )
  // Set leftMargin based on user token and window width
  useEffect(() => {
    const handleResize = () => {
      // Update leftMargin on window resize
      setLeftMargin(
        user.token ? (window.innerWidth > 1100 ? '250px' : '0px') : '0px'
      )
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [window.innerWidth, user.token])

  return (
    <div
      className={'GameroomsAd'}
      style={{
        left: leftMargin,
        paddingRight: leftMargin,
      }}
    >
      <BannerAd AdUnitId={AdUnitId} />
    </div>
  )
}

GameroomsAd.propTypes = {
  AdUnitId: PropTypes.string.isRequired,
}

export default GameroomsAd
